import { Component, h, Prop, Watch, Event, EventEmitter, Element } from '@stencil/core';

export type SortOption = 'date-desc' | 'date-asc' | 'az-desc' | 'az-asc';

const LABELS = {
  'date-desc': 'Latest',
  'date-asc': 'Oldest',
  'az-desc': 'Z-A',
  'az-asc': 'A-Z',
}

@Component({
  tag: 'hd-sort-dropdown',
  styleUrl: 'hd-sort-dropdown.pcss',
  shadow: true
})
export class HdSortDropdown {
  @Prop({ reflect: true, mutable: true }) open: boolean = false;
  @Prop({ reflect: true, mutable: true }) selected: SortOption | null = null;
  @Prop() alignPosition: 'left' | 'right' = 'right';
  @Event() onSortChange: EventEmitter<SortOption>;
  @Element() hostElement: HTMLElement;

  @Watch('selected')
  handleSelectedChange(selected: SortOption | null) {
    this.selected = selected;
    this.onSortChange.emit(selected);
    this.open = false;
  }

  componentDidLoad() {
    document.addEventListener('click', this.handleClickOutside);
  }

  disconnectedCallback() {
    document.removeEventListener('click', this.handleClickOutside);
  }

  private handleClickOutside = (event: MouseEvent) => {
    if (this.open && !this.hostElement.contains(event.target as Node)) {
      this.open = false;
    }
  };

  render() {
    return (
      <div class="container">
        <button class="trigger-btn" onClick={() => this.open = !this.open}>
          <hd-icon svg="sort" width="16" height="16" />
          <span>{this.selected ? LABELS[this.selected] : 'Sort'}</span>
        </button>
        {this.open && (
          <div class={`dropdown-content ${this.alignPosition}`}>
            <button class="close-btn" onClick={() => this.open = false}>
              <hd-icon svg="cancel" width="12" height="12"></hd-icon>
            </button>
            <div class="dropdown-item">
              <h4 class="item-title">Date</h4>
              <label>
                <input type="radio" name="sort" value="date-desc"
                  checked={this.selected === 'date-desc'} onChange={() => this.selected = 'date-desc'} />
                <span>Latest</span>
              </label>
              <label>
                <input type="radio" name="sort" value="date-asc"
                  checked={this.selected === 'date-asc'} onChange={() => this.selected = 'date-asc'} />
                <span>Oldest</span>
              </label>
            </div>
            <div class="dropdown-item">
              <h4 class="item-title">Alphabetically</h4>
              <label>
                <input type="radio" name="sort" value="az-asc"
                  checked={this.selected === 'az-asc'} onChange={() => this.selected = 'az-asc'} />
                <span>A-Z</span>
              </label>
              <label>
                <input type="radio" name="sort" value="az-desc"
                  checked={this.selected === 'az-desc'} onChange={() => this.selected = 'az-desc'} />
                <span>Z-A</span>
              </label>
            </div>
            <button class="reset-btn" onClick={() => this.selected = null}>Reset</button>
          </div>
        )}
      </div>
    );
  }
}
